<template>
    <v-container fluid pa-4 :class="$style['container']">
        <h3>MARRIAGE LICENSE QUESTIONNAIRE</h3>
        <v-divider></v-divider>
        <div :class="$style['container-ws']">
            <marriage-ws-header />
        </div>
        <v-divider></v-divider>
        <br />
        <div :class="$style['container-ws']">
            <marriage-ws-form
                v-show="!isLoading"
                ref="marriageWsForm"
                @form-data="getFormData"
                :canEdit="canEdit"
                :countyProp="marriageWorksheet.countyClerkFacilityId"
                :applicantsProp="marriageWorksheet.applicants"
                @on-print="print"
                @county-changed="countyChanged"
                @print-no-save="printWorksheetNoSave"
            />
            <v-progress-circular v-if="isLoading" indeterminate :size="65" :width="5"></v-progress-circular>
        </div>
        <br />
        <v-divider></v-divider>
        <br />
        <div v-if="!printOnlyCounty || true" v-show="!isLoading && selectedCountyId">
            <div :class="$style['container-image-upload']">
                <h4>Upload Valid Government Issued IDs</h4>
                <p>
                    (Driver’s License, State ID Card, Passport, Tribal ID)<br />
                    *If signature is located on the back, provide images of both sides (Driver’s License, State ID Card,
                    Passport, Tribal ID)<br />
                    *If signature is located on the back, provide images of both sides
                </p>
                <media-uploader v-show="!isLoading" :disabled="!canEdit" ref="imageListRef" :moduleId="150" :parentId="marriageWorksheet.marriageWorksheetId" @on-upload="mediaOnUpload" />
                <!-- <v-progress-circular v-if="isLoading" indeterminate :size="65" :width="5"></v-progress-circular> -->
            </div>
            <div :class="$style['container-ws']">
                <br>
                <marriage-ws-ack v-show="!isLoading" :canEdit="canEdit" ref="marriageAckForm" :selectedAckProp="marriageWorksheet.acks" @on-check="saveUnfinished" />
                <!-- <v-progress-circular v-if="isLoading" indeterminate :size="65" :width="5"></v-progress-circular> -->
            </div>
            <div v-if="messages">
                <br>
                <div v-for="msg in messages" :key="msg.message">
                    <span :style="{'color': msg.color}">{{ msg.message }}</span>
                </div>
            </div>
            <br />
            <div :class="$style['bottom-controls']" v-show="!isLoading">
                <!-- <v-btn>Help</v-btn> -->
                <v-btn v-if="canEdit" :disabled="isBtnsLoading" color="secondary" @click="saveUnfinished">Save Unfinished</v-btn>
                <v-btn v-if="canEdit" :disabled="isBtnsLoading" color="primary" :class="$style['right']" @click="submit">Submit</v-btn>
            </div>
        </div>
    </v-container>
</template>

<script>
import moment from 'moment'
import MarriageWsHeader from '../components/marriageWorksheet/MarriageWsHeader.vue'
import MarriageWsForm from '../components/marriageWorksheet/MarriageWsForm.vue'
import marriageWsService from '@/services/marriageWorksheetService'
import MediaUploader from '../components/MediaUploader'
import MarriageWsAck from '../components/marriageWorksheet/MarriageWsAck.vue'
import mediaService from '@/services/mediaService'

export default {
    name: 'marriage-worksheet',
    components: {
        MarriageWsHeader,
        MarriageWsForm,
        MediaUploader,
        MarriageWsAck
    },
    data: () => {
        return {
            isLoading: true,
            isBtnsLoading: false,
            marriageWorksheet: {
                marriageWorksheetId: null,
                countyClerkFacilityId: null,
                status: marriageWsService.WsStatusEnum.New,
                applicants: [{}, {}],
                acks: []
            },
            worksheetStatus: null,
            messages: [
                {
                    message: null,
                    color: null
                }
            ],
            printOnlyCountyIds: [15126, 15128],
            selectedCountyId: null
        }
    },
    computed: {
        canEdit () {
            return !this.worksheetStatus || this.worksheetStatus === marriageWsService.WsStatusEnum.New
        },
        printOnlyCounty () {
            return this.printOnlyCountyIds.includes(this.selectedCountyId)
        }
    },
    mounted () {
        this.load()
    },
    methods: {
        load () {
            this.marriageWorksheet.marriageWorksheetId = Number(this.$route.query.marriageWsId)
            if (this.marriageWorksheet.marriageWorksheetId) {
                this.setupExistingWs()
            } else {
                this.isLoading = false
                this.marriageWorksheet = {
                    marriageWorksheetId: null,
                    countyClerkFacilityId: null,
                    status: marriageWsService.WsStatusEnum.New,
                    applicants: [
                        marriageWsService.createNewApplicant(),
                        marriageWsService.createNewApplicant()
                    ],
                    acks: []
                }
            }
        },
        getFormData (formData) {
            this.marriageWorksheet.applicants = []
            this.marriageWorksheet.applicants = formData.applicants
            this.marriageWorksheet.countyClerkFacilityId = formData.countyClerkFacilityId
        },
        setupExistingWs () {
            this.isLoading = true
            marriageWsService
                .marriageWsGet(this.$http, this.marriageWorksheet.marriageWorksheetId)
                .then(response => {
                    if (response.data) {
                        // handle date formats
                        response.data.applicants.forEach(element => {
                            element.dateOfBirth = element.dateOfBirth
                                ? moment(element.dateOfBirth).format('yyyy-MM-DD')
                                : null
                            element.divorceDate = element.divorceDate
                                ? moment(element.divorceDate).format('yyyy-MM-DD')
                                : null
                            element.widowedDate = element.widowedDate
                                ? moment(element.widowedDate).format('yyyy-MM-DD')
                                : null
                        })
                        this.marriageWorksheet = response.data
                        this.selectedCountyId = this.marriageWorksheet.countyClerkFacilityId
                    }
                    this.isLoading = false
                })
                .catch(error => {
                    this.onError(error)
                })

            marriageWsService
                .marriageWsGetStatus(this.$http, this.marriageWorksheet.marriageWorksheetId)
                .then(response => {
                    this.worksheetStatus = response.data.portalMarriageWorksheetStatusId
                })
                .catch(error => {
                    this.onError(error)
                })
        },
        validate () {
            var valid = []
            valid.push(this.$refs.marriageAckForm.validate())
            valid.push(this.$refs.marriageWsForm.validate())

            return !valid.includes(false)
        },
        submit () {
            this.messages = []
            this.isLoading = true

            if (!this.validate()) {
                this.messages.push({ message: 'Please fill in all required fields to submit.', color: 'red' })
                this.isLoading = false
                return
            }

            this.$refs.marriageWsForm.getFormData()
            this.marriageWorksheet.acks = this.$refs.marriageAckForm.selectedAck
            marriageWsService
                .marriageWsSubmit(this.$http, this.marriageWorksheet)
                .then(response => {
                    this.isLoading = false
                    if (response.data.isValid) {
                        alert('Your marriage worksheet is submitted!')
                        this.$router.push('/inbox')
                    }
                    response.data.errorMessages.forEach(o => this.messages.push(({
                        message: o,
                        color: 'red'
                    })))
                })
                .catch(error => {
                    this.onError(error)
                })
        },
        saveUnfinished (silent) {
            this.isBtnsLoading = true
            this.isLoading = !silent
            this.$refs.marriageWsForm.getFormData()
            this.marriageWorksheet.acks = this.$refs.marriageAckForm.selectedAck
            if (!this.marriageWorksheet.countyClerkFacilityId) {
                this.messages = []
                this.messages.push({
                    message: 'County office is required to get started.',
                    color: 'red'
                })
                this.isLoading = false
                this.isBtnsLoading = false
                return
            }

            return new Promise((resolve, reject) => {
                marriageWsService.marriageWsSaveUnfinished(this.$http, this.marriageWorksheet)
                    .then(async response => {
                        this.messages = []
                        this.marriageWorksheet.marriageWorksheetId = response.data
                        if (this.$refs.imageListRef) await this.$refs.imageListRef.saveMedia(response.data, 150)
                        //if (this.$refs.marriageAckForm) this.$refs.marriageAckForm.saveAck(response.data)
                        this.messages.push({
                            message: 'Worksheet Saved - This worksheet can be continued via your inbox.',
                            color: 'green'
                        })
                        this.isLoading = false
                        this.isBtnsLoading = false
                        if (!this.$route.query.marriageWsId || Number(this.$route.query.marriageWsId) !== this.marriageWorksheet.marriageWorksheetId) {
                            this.$router.push('/marriage-worksheet?marriageWsId=' + this.marriageWorksheet.marriageWorksheetId)
                        }
                        // if (!silent) this.load()
                        resolve()
                    })
                    .catch(error => {
                        this.onError(error)
                        this.isLoading = false
                        this.isBtnsLoading = false
                        reject(error)
                    })
            })
        },
        onError (error) {
            console.error(error) // eslint-disable-line no-console
            this.messages.push({
                message: 'A critical error occurred. Please contact the site administrator.',
                color: 'red'
            })
        },
        print () {
            this.saveUnfinished().then(() => {
                marriageWsService.print(this.$http, this.marriageWorksheet.marriageWorksheetId).then(response => {
                    mediaService.downloadMedia('application/pdf', response.data, 'MarriageQuestionnaire.pdf')
                    this.$refs.marriageWsForm.isPrinting = false
                }).catch(() => { this.$refs.marriageWsForm.isPrinting = false })
            })
        },
        printWorksheetNoSave () {
            this.print()
            // this.$refs.marriageWsForm.getFormData()
            // marriageWsService.worksheetPrint(this.$http, this.marriageWorksheet).then(response => {
            //     mediaService.downloadMedia('application/pdf', response.data, 'MarriageQuestionnaire.pdf')
            //     this.$refs.marriageWsForm.isPrinting = false
            // }).catch(() => { this.$refs.marriageWsForm.isPrinting = false })
        },
        countyChanged (val) {
            this.selectedCountyId = val
        },
        help () {
            // TODO ?
        },
        mediaOnUpload () {
            if (!this.$refs.imageListRef) return
            if (this.marriageWorksheet.marriageWorksheetId) {
                this.$refs.imageListRef.saveMedia(this.marriageWorksheet.marriageWorksheetId, 150)
            } else {
                this.saveUnfinished(true)
            }
        }
    }
}
</script>

<style scoped>
h4 {
    font-weight: 500 !important;
}
</style>

<style module>
.container {
    max-width: 2160px;
}
.container-ws {
    display: flex;
    margin: 0px 32px 0px 32px;
    justify-content: center;
}

.container-image-upload {
    margin: 0px 28px 0px 28px;
    justify-content: center;
}

.bottom-controls {
    display: flex;
    justify-content: center;
}

.bottom-controls .right {
    margin-left: 64px;
}
</style>
